// Don't change! This file is auto-generated
const urlSlugItems = {
  stores: 'stores',
  newsletter: 'newsletter',
  returnPage: 'returns',
  newsPage: 'news',
  toursPage: 'tours',
  arrangementParent: 'tours/arrangements',
  watches: 'watches',
  brands: 'brands',
  sizeInformation: 'determine-ring-size',
  faqPage: 'frequently-asked-questions',
  armbanden: 'bracelets',
  colliers: 'necklaces',
  diamanten_armbanden: 'diamond-bracelets',
  diamanten_colliers: 'diamond-necklaces',
  oorbellen: 'earrings',
  ringen: 'rings',
  trouwringen_sets: 'wedding-rings-sets',
  untitled_content_item_250447f: 'diamond-rings',
  untitled_content_item_c68c114: 'diamond-earrings',
}
export default urlSlugItems
export type UrlSlugMessages = typeof urlSlugItems
